export default __webpack_public_path__ + "static/sweepstakes-prize-02-4b061fe60164651f104a2c8cea91eae0.jpg";